// extracted by mini-css-extract-plugin
export var highlightFade = "_44-4";
export var highlighted = "_44-3";
export var table = "_44-1";
export var tableContainer = "_44-0";
export var totalsRow = "_44-2";